// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__gZDeq","input":"styles_input__1EIs9"};